// extracted by mini-css-extract-plugin
export default {"container":"Account_container__Q2IGr","user":"Account_user__HKLPe"};